import { css } from '@emotion/core';
import { applyFont, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var newHomesListingCardDetails = /*#__PURE__*/css("display:flex;flex-direction:column;color:", colors.neutral.heavy.default, ";", applyFont(typography.body), ";");
export var type = /*#__PURE__*/css(applyFont(typography.miniBold));
export var address = {
  name: "1ofa1mm",
  styles: "display:inline-block;[data-new-dev-layout='three-column'] &{display:block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}"
};
export var link = {
  name: "y7q6ij",
  styles: "text-decoration:none;color:inherit;&::before{position:absolute;top:0;right:0;left:0;bottom:0;z-index:2;content:'';}"
};